import { AiChatProviderName } from "../../../../../services/ai-chat-service";
import type { BalanceInfo, McpChatBalancePanelProps } from "./mcp-chat-balance-panel";

type BalancePanelController = {
  state: {
    isBalancePanelOpen: boolean;
    balanceInfo: BalanceInfo | null;
    serverProvider: AiChatProviderName | null;
  };
  handleBalancePanelToggle: () => void;
  handleGoToTopUp: () => void;
};

interface BalancePanelHostUserInfo {
  isDomainOwner?: boolean;
}

interface BalancePanelHostWindow extends Window {
  userInfo?: BalancePanelHostUserInfo;
}

function isCurrentUserDomainOwner(): boolean {
  if (typeof window === "undefined") return false;
  const host = window as BalancePanelHostWindow;
  return !!host.userInfo?.isDomainOwner;
}

export function buildMcpChatBalancePanelProps(panel: BalancePanelController): McpChatBalancePanelProps | null {
  // On-prem deployments (non-OpenRouter providers) have no credit billing,
  // so the balance popover is hidden — same gate as the model selector.
  if (panel.state.serverProvider !== AiChatProviderName.OpenRouter) {
    return null;
  }
  if (!panel.state.isBalancePanelOpen || !panel.state.balanceInfo) {
    return null;
  }

  return {
    isOpen: panel.state.isBalancePanelOpen,
    onToggle: panel.handleBalancePanelToggle,
    balance: panel.state.balanceInfo,
    onGoToTopUp: isCurrentUserDomainOwner() ? panel.handleGoToTopUp : undefined
  };
}
